class topBar {
    constructor() {
        document.querySelectorAll("[data-apply-btn]").forEach(ele=>{
            ele.addEventListener("click" , (event)=>{
                this.topbarDiscountClickHandler(event);
            })
        });
        if (window.globalVariables.templateSuffix == 'subscription-flow') {
            let currentPage = window.location.search;
            currentPage = window.location.search.replace("?currentProduct=" ,"");
            currentPage = currentPage.trim();
            document.querySelectorAll("[data-discount-top-bar]").forEach(ele=>{
                let checkcurrentPage = ele.getAttribute('data-discount-top-bar');
                if(checkcurrentPage == currentPage){
                    ele.classList.remove("d-none");
                }
            })
        }

    //   document
    //     .getElementById("topbar-discount-btn")
    //     .addEventListener("click", (e) => this.topbarDiscountClickHandler(e));
    }
  
    checkForAppliedCoupon(button) {
    //   const btn = document.getElementById("topbar-discount-btn");
    const btn = button;

      btn.disabled = true;
      btn.classList.add("disabled");
      btn.querySelector(".add-text").textContent = btn.dataset.afterText;
    }
  
    async topbarDiscountClickHandler(event) {
    //   let button = document.getElementById("topbar-discount-btn");
      let button = event.currentTarget;
      let discountCode = button.dataset.code;
      if (!discountCode) return;
      button.querySelector(".spinner").classList.add("d-block");
      button.querySelector(".add-text").classList.add("d-none");
      button.disabled = true;
      button.classList.add("disabled");
  
      try {
        await fetch(`/discount/${discountCode}`);
        if (window.globalVariables.template == "cart") window.location.reload();
        this.checkForAppliedCoupon(button);
      } catch (error) {
        console.log("error while applying discount", error);
        button.disabled = false;
        button.classList.remove("disabled");
      } finally {
        button.querySelector(".spinner").classList.remove("d-block");
        button.querySelector(".add-text").classList.remove("d-none");
      }
    }
  }
  
  typeof topBar !== "undefined" && new topBar();
  